import React from 'react'
import classNames from 'classnames'
import styles from './styles.module.css'
import { ProgressBarProps } from './types'
import { ProgressProps } from './types'
import { formatCents } from 'utils'

export const Progress = ({ project, status }: ProgressProps) => {
  return (
    <>
      <div className={classNames(styles.container, 'mt-4')}>
        <div className={styles.amountTextContainer}>
          <strong className={classNames(styles.number, styles.largeNumber, 'mb-1')}>
            {formatCents(i18n.locale, project.donated_amount_in_cents)}
          </strong>

          {project.open_amount_in_cents !== 0 && (
            <span>
              {i18n.t('projects.show.stats.of_GOAL_collected', {
                goal: formatCents(i18n.locale, project.donated_amount_in_cents + project.open_amount_in_cents),
              })}
            </span>
          )}
        </div>
      </div>
      <ProgressBar percentage={project.progress_percentage} />
      <div className={classNames('generic-big-numbers is-compressed mb-2', `is-${status}`)}>
        <div className={styles.progressTextContainer}>
          <div>
            <span className={classNames(styles.number, 'mr-2')}>{project.progress_percentage} %</span>
            <span>{i18n.t('projects.show.stats.percentage_label')}</span>
          </div>
          <div>
            <span className={classNames(styles.number, 'mr-2')}>{project.donations_count}</span>
            <span>{i18n.t('projects.show.stats.donations_count_label', { count: project.donations_count })}</span>
          </div>
        </div>
      </div>
    </>
  )
}

const ProgressBar = ({ percentage }: ProgressBarProps): JSX.Element | null => {
  return (
    <div className="progress generic-progress-bar mb-4 mt-2">
      <div className="bar" style={{ width: `${percentage}%` }}></div>
    </div>
  )
}
